module.exports = __webpack_public_path__ + "static/media/water2.16eba381.jpg";